import React from 'react';
import { Box, Card, CardContent, Skeleton, Stack } from '@mui/material';
import Grid from '@mui/material/Grid';

const ProfileLoadingSkeleton = () => (
  <>
    {/* Header skeleton */}
    <Card sx={{ overflow: 'hidden', mb: 3 }}>
      <Skeleton variant="rectangular" sx={{ height: { xs: 140, sm: 160, md: 180 } }} />
      <CardContent sx={{ p: { xs: 3, md: 4 }, textAlign: 'center', mt: -5 }}>
        <Skeleton
          variant="circular"
          width={96}
          height={96}
          sx={{ mx: 'auto', mb: 2, border: '4px solid white' }}
        />
        <Skeleton variant="text" width={160} sx={{ mx: 'auto', mb: 0.5 }} />
        <Skeleton variant="text" width={120} sx={{ mx: 'auto', mb: 1 }} />
        <Skeleton variant="text" width={240} sx={{ mx: 'auto', mb: 1 }} />
        <Stack direction="row" spacing={1} justifyContent="center" sx={{ mb: 2 }}>
          <Skeleton variant="rounded" width={80} height={28} />
          <Skeleton variant="rounded" width={60} height={28} />
          <Skeleton variant="rounded" width={70} height={28} />
        </Stack>
        <Skeleton variant="text" width={200} sx={{ mx: 'auto' }} />
      </CardContent>
    </Card>

    {/* Grid skeleton — 4 cards in 2-col grid */}
    <Grid container spacing={2}>
      {[0, 1, 2, 3].map((i) => (
        <Grid item xs={12} md={6} key={i}>
          <Skeleton variant="rounded" height={100} />
        </Grid>
      ))}
    </Grid>
  </>
);

export default ProfileLoadingSkeleton;
